import { FiSearch } from "react-icons/fi";
import { TfiTimer } from "react-icons/tfi";
import { BsSortDown } from "react-icons/bs";
import { useEffect, useRef, useState } from "react";
import { userServices } from "../../APIServices/UserData/userServices";
import { Button, Card, Collapse, Container, Form, InputGroup, ListGroup } from "react-bootstrap";
import { FaBan, FaCheck, FaClock, FaEnvelope, FaUser, FaUsers, FaUserTie } from "react-icons/fa";
import Swal from "sweetalert2";
import Moment from "react-moment";
import SplitPane from "react-split-pane";
import { GrOrganization } from "react-icons/gr";
import { DataNotFound, ListLoader } from "../../Hooks/PageLoader";
import { RiAccountPinBoxFill } from "react-icons/ri";

const MemberManagement = ({ currentUserData, isDark, auth, accountList }) => {
  const AppRef = useRef(null);
  const [userId, setUserId] = useState("");
  const [status, setStatus] = useState("all");
  const [members, setMembers] = useState([]);
  const [assignedAccount, setAssignedAccount] = useState([]);
  const [memberCount, setMemberCount] = useState(0);
  const [memberData, setMemberData] = useState("");
  const [openSort, setOpenSort] = useState(false);

  const [searchData, setSearchData] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [listLoader, setListLoader] = useState(false)

  const getMembers = async () => {
    setListLoader(true)
    let data = await userServices.getMembers(auth, status, searchData, pageNumber, itemsPerPage)
    setMembers(data?.data || [])
    setMemberCount(data?.count || 0)
    setListLoader(false)
  }

  useEffect(() => {
    getMembers()
  }, [auth, status, searchData, pageNumber, itemsPerPage]);

  const [itemDataLoader, setItemDataLoader] = useState(false);

  const getSingleMember = async (userId) => {
    setItemDataLoader(true)
    let data = await userServices.getSingleMember(auth, userId)
    setMemberData(data?.data || [])
    setAssignedAccount(data?.data?.assignedAccount || [])
    setItemDataLoader(false)
  }

  const statusUpdateMember = async (userId, adminId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${status === "active" ? "Activate" : "Deactivate"} this Member?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status === "active" ? "Activate" : "Deactivate"} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.adminId = adminId
        userData.userId = userId
        userData.status = status
        userData.type = "status"
        let data = await userServices.statusUpdateMember(auth, userData)
        if (data?.statusCode === 200) {
          getMembers()
          getSingleMember(userId)
        }
      }
    });
  };

  const assignAccountMember = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Assign Seelcted Account of this Member?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Assign it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.adminId = memberData?.adminId
        userData.userId = memberData?.userId
        userData.assignedAccount = assignedAccount
        userData.type = "assign"
        let data = await userServices.statusUpdateMember(auth, userData)
        if (data?.statusCode === 200) {
          getMembers()
          getSingleMember(userId)
        }
      }
    });
  };

  const handleCheckbox = (accountId, checked) => {
    if (checked) {
      setAssignedAccount((prev) => [...prev, accountId]);
    } else {
      setAssignedAccount((prev) => prev.filter((id) => id !== accountId));
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setAssignedAccount(accountList.map((m) => m.accountId));
    } else {
      setAssignedAccount([]);
    }
  };

  useEffect(() => {
    if (userId) {
      getSingleMember(userId)
    }
  }, [auth, userId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppRef.current && !AppRef.current.contains(event.target)) {
        setOpenSort(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <div className="position-relative">
      <div className="p-2 hstack gap-2 border-bottom">
        <InputGroup>
          <Form.Select
            className="interactive-input"
            style={{ fontSize: 12, padding: "6px 15px", width: "20%" }}
            onChange={(e) => setStatus(e.target.value)}
            value={status}
          >
            <option value="all">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </Form.Select>
          <FiSearch className="position-absolute" style={{ top: 11, left: "26.5%", zIndex: 99 }} />
          <Form.Control onChange={(e) => setSearchData(e.target.value)} values={searchData} type="search" className="interactive-input py-2 ps-5" title="Search Here..." style={{ fontSize: 12, width: "70%" }} placeholder={`Search by Name and Email...`} />
        </InputGroup>
      </div>
      <SplitPane split="vertical" minSize={"25%"} className="position-relative">
        <div style={{ height: "100vh" }}>
          <div className="p-2 pb-1 hstack justify-content-between gap-2">
            <Button variant={isDark ? "outline-dark" : "outline-light"} className={`${!isDark ? "text-dark" : "text-white"} py-1 px-2 rounded-1 hstack gap-2`} title="Members"><FaUsers /> <span style={{ fontSize: 14 }}>Members ({memberCount})</span></Button>
            <div className="position-relative">
              <Button variant={openSort ? "primary" : isDark ? "outline-dark" : "outline-light"} ref={AppRef} onClick={() => setOpenSort(!openSort)} className={`${openSort ? "text-white" : isDark ? "text-white border" : "text-dark"} py-1 px-2 rounded-1`} title="Sort items"><BsSortDown /></Button>
              <Collapse in={openSort}>
                <ListGroup className="position-absolute text-nowrap shadow-sm" style={{ zIndex: 99, right: -9, top: 35, fontSize: 13 }}>
                  <ListGroup.Item action className="py-1"><Form.Check className="m-0 mt-1 CP" name="sortBy" type="radio" label="By Email" /></ListGroup.Item>
                  <ListGroup.Item action className="py-1"><Form.Check checked className="m-0 mt-1 CP" name="sortBy" type="radio" label="Date Created" /></ListGroup.Item>
                  <ListGroup.Item action className="py-1"><Form.Check className="m-0 mt-1 CP" name="sortBy" type="radio" label="Date Modified" /></ListGroup.Item>
                  <ListGroup.Item action className="py-1"><Form.Check className="m-0 mt-1 CP" name="sortFor" type="radio" label="Newest First" /></ListGroup.Item>
                  <ListGroup.Item action className="py-1"><Form.Check checked className="m-0 mt-1 CP" name="sortFor" type="radio" label="Oldest First" /></ListGroup.Item>
                </ListGroup>
              </Collapse>
            </div>
          </div>
          <div className="px-2 text-center pb-2">
            <Form.Label className="mb-0" style={{ fontSize: 12, color: "#94a3b8", userSelect: "none" }}>Oldest First | Date Created</Form.Label>
          </div>
          <div className="px-2 pb-2 overflow-auto" style={{ height: "calc(100vh - 131px)" }}>
            {listLoader ? <ListLoader /> : members?.length > 0 ? (
              <div className="item-list">
                {members.map((item, index) => {
                  const isActive = userId === item?.userId;
                  return (
                    <div
                      key={index}
                      className={`member-card border ${isActive ? item?.status === "inactive" ? "border-danger bg-danger-subtle" : "border-success bg-success-subtle" : ""}`}
                      onClick={() => setUserId(item?.userId)}
                      role="button"
                    >
                      <div className="text-center">
                        <div className={`avatar m-auto ${item?.status === "inactive" ? "bg-danger" : "bg-success"}`}>
                          {item?.name?.charAt(0)?.toUpperCase()}
                        </div>
                      </div>
                      <div className="member-info">
                        <div className="member-name">
                          {item?.roleType === "organization" ? <GrOrganization /> : <FaUser />} {item?.name}
                        </div>
                        <div className="member-email">
                          <FaEnvelope /> {item?.email}
                        </div>
                        <div className="member-email">
                          <TfiTimer /> <Moment format="DD MMM YYYY | HH:mm" withTitle>{item?.createdAt}</Moment>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="item-empty-state">
                <span>No members found</span>
              </div>
            )}
          </div>
        </div>
        <div style={{ height: "100vh" }}>
          {itemDataLoader ? <ListLoader /> : memberData ? (
            <>
              <Container fluid>
                <Form.Group className={`pt-4 px-0 overflow-auto`} style={{ height: "calc(100vh - 26px)" }}>
                  <div className={`w-50 m-auto`}>
                    <Card className="shadow-sm border mb-3">
                      <Card.Header className="fw-bold border-bottom hstack justify-content-between">
                        <span> {memberData?.roleType === "individual" ? "Member" : "Organization"} Details </span>
                        {currentUserData?.roleType === "organization" &&
                          <>
                            {memberData?.status === "active" ? (
                              <Button
                                onClick={() =>
                                  statusUpdateMember(memberData?.userId, memberData?.adminId, "inactive")
                                }
                                variant="outline-danger"
                                size="sm"
                                className="hstack gap-1 rounded-1"
                                style={{ fontSize: 10 }}
                              >
                                <FaBan /> Deactivate
                              </Button>
                            ) : (
                              <Button
                                onClick={() =>
                                  statusUpdateMember(memberData?.userId, memberData?.adminId, "active")
                                }
                                variant="outline-success"
                                size="sm"
                                className="hstack gap-1 rounded-1"
                                style={{ fontSize: 10 }}
                              >
                                <FaCheck /> Activate
                              </Button>
                            )}
                          </>
                        }
                      </Card.Header>
                      <Card.Body>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div style={{ fontSize: 13 }} className="text-muted small d-flex align-items-center gap-2">
                            {memberData?.roleType === "organization" ? <GrOrganization /> : <FaUser />} Name
                          </div>
                          <div className="fw-semibold" style={{ fontSize: 13 }}>
                            {memberData?.name}
                          </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                          <div style={{ fontSize: 13 }} className="text-muted small d-flex align-items-center gap-2">
                            <FaEnvelope /> Email
                          </div>
                          <div className="fw-semibold" style={{ fontSize: 13 }}>
                            {memberData?.email}
                          </div>
                        </div>
                        {memberData?.roleType === "individual" &&
                        <>
                          <div className="d-flex justify-content-between align-items-center my-3">
                            <div style={{ fontSize: 13 }} className="text-muted small d-flex align-items-center gap-2">
                              <FaUserTie /> Role
                            </div>
                            <div className="fw-semibold" style={{ fontSize: 13 }}>
                              Member
                            </div>
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            <div style={{ fontSize: 13 }} className="text-muted small d-flex align-items-center gap-2">
                              <FaClock /> Joined On
                            </div>
                            <div className="fw-semibold" style={{ fontSize: 13 }}>
                              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                {memberData?.createdAt}
                              </Moment>
                            </div>
                          </div>
                        </>
                        }
                        {currentUserData?.roleType === "organization" &&
                          <>
                            <div className="d-flex justify-content-between align-items-center my-3">
                              <div style={{ fontSize: 13 }} className="text-muted small d-flex align-items-center gap-2">
                                <RiAccountPinBoxFill style={{ fontSize: 15, marginLeft: -2 }} /> Assign Accounts
                              </div>
                            </div>
                            {accountList?.length > 0 && (
                              <Form.Check
                                type="checkbox"
                                label="Select All"
                                checked={assignedAccount?.length === accountList?.length}
                                onChange={(e) => handleSelectAll(e.target.checked)}
                                style={{ fontSize: 12 }}
                              />
                            )}
                            {accountList?.map((item, index) => (
                              <Form.Check
                                key={index}
                                type="checkbox"
                                disabled={item?.status === "inactive"}
                                label={item?.name}
                                checked={assignedAccount?.includes(item.accountId)}
                                onChange={(e) => handleCheckbox(item.accountId, e.target.checked)}
                                style={{ fontSize: 12 }}
                              />
                            ))}
                            <Button
                              onClick={assignAccountMember}
                              variant="outline-primary"
                              size="sm"
                              disabled={assignedAccount?.length === 0}
                              className="hstack gap-1 rounded-1 mt-3"
                              style={{ fontSize: 10 }}
                            >
                              <FaCheck /> Assign Now
                            </Button>
                          </>
                        }
                      </Card.Body>
                    </Card>
                  </div>
                </Form.Group>
              </Container>
            </>
          ) : (
            <DataNotFound msg={`Member details not found.`} />
          )}
        </div>
      </SplitPane >
    </div >
  );
};

export default MemberManagement;